import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';

import FormGroup from '~/commons/components/FormGroup.jsx';
import { useCompetitions } from '../../../contexts/Competitions';

const FieldsCompPicker = ({
  questionSet = false,
}) => {
  const { competitions } = useCompetitions();
  const {
    values,
    touched,
    setFieldValue,
  } = useFormikContext();
  let qSet = [];

  if (questionSet) {
    qSet = competitions
      .find((c) => c._id === values.competition)
      ?.questionSets || [];
  }

  useEffect(() => {
    if (questionSet) {
      const hasQSet = qSet.find((q) => q._id === values.questionSet);

      if (!hasQSet) {
        setFieldValue('questionSet', '');
      }
    }
  }, [touched.competition, values.competition]);

  return (
    <div className="form-row">
      <div className="col">
        <FormGroup
          name="competition"
          as="select"
        >
          <option value=""> - </option>
          {competitions.map((c) => (
            <option key={c._id} value={c._id}>
              {c.refCode}
            </option>
          ))}
        </FormGroup>
      </div>
      {questionSet && (
        <div className="col">
          <FormGroup
            name="questionSet"
            as="select"
          >
            <option value=""> - </option>
            {qSet.map((qs) => (
              <option key={qs._id} value={qs._id}>
                {qs.refCode}
              </option>
            ))}
          </FormGroup>
        </div>
      )}
    </div>
  );
};

export default FieldsCompPicker;
